import { Directive, OnInit, AfterViewInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { delay, distinctUntilChanged } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { InputAutocompleteComponent } from '@nimbus-library/features/shared/components/material/input-autocomplete/input-autocomplete.component';

@UntilDestroy()
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'nimbus-input-autocomplete[defaultSearch]',
  standalone: false,
})
export class InputAutocompleteDefaultSearchDirective implements OnInit, AfterViewInit {
  private readonly scrollOffset = 75;

  public constructor(private readonly host: InputAutocompleteComponent) {}

  public ngOnInit(): void {
    concat(of(this.host.autoCompleteControl.value), this.host.autoCompleteControl.valueChanges)
      .pipe(untilDestroyed(this), distinctUntilChanged())
      .subscribe((val) => {
        const filterVal = (typeof val === 'string' ? val : val?.name)?.toLowerCase().trim();
        const exactMatch = this.host.options?.find((o) => o.name.toLowerCase() === filterVal);

        if (typeof val !== 'string' && exactMatch) {
          this.host.filteredOptions$.next([exactMatch]);
        } else {
          const result = filterVal
            ? this.host.options?.filter((o) => o.name.toLowerCase().includes(filterVal) || o.id === this.host.noRecordsItem.id)
            : this.host.options;
          this.host.filteredOptions$.next(result?.length ? result : [this.host.noRecordsItem]);
        }
      });
  }

  public ngAfterViewInit(): void {
    this.host.autocomplete.opened.pipe(delay(0), untilDestroyed(this)).subscribe(() => {
      const val = this.host.ngControl.value;
      if (val) {
        const searchVal = typeof val === 'string' ? val : val?.name;
        const index = this.findOptionIndexByValue(searchVal);

        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        if (index !== -1) {
          this.activateOption(index);
        }
      }
    });
  }

  private findOptionIndexByValue(value: string): number {
    return this.host.options.findIndex((o) => o.id === value || o.name.toLowerCase().includes(value?.toLowerCase()));
  }

  private activateOption(index: number): void {
    const option = this.host.autocomplete.options.get(index);
    this.host.autocomplete._keyManager.setActiveItem(option);
    (this.host.autocomplete.panel?.nativeElement as HTMLElement)?.scrollTo(0, option._getHostElement().offsetTop - this.scrollOffset);
  }
}
